/**
 * Toggle hero chart disclaimer.
 * @returns void
 */
const rating_disclaimer = () => {
	// Exit as soon as possible.
	const promos = document.querySelectorAll('.ratings-block .promo-item');
	if (!promos) return;

	promos.forEach(promo => {
		const trigger = promo.querySelector('.disclaimer-toggle');
		const disclaimer_text = promo.querySelector('.promo-disclaimer-full');
		// Exit if disclaimer is hidden.
		if (!trigger || !disclaimer_text) return

		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			// Toggle disclaimer visibilty.
			disclaimer_text.classList.toggle('open');
			trigger.classList.toggle('open');
		})
	})
}

document.addEventListener("DOMContentLoaded", () => {
	rating_disclaimer();
})
